<template lang="html">
<b-th>
    <div class="ipam-header text-center">
        <template v-if="isTag">
            <b-badge ref="tagBadge" variant="info" class="d-block">{{ display.name }}</b-badge>
            <b-popover :target="() => $refs.tagBadge" triggers="hover" placement="bottom">
                <div v-for="d in display.displays.slice().sort((a, b) => a.name.localeCompare(b.name))" :key="d.displayId">{{ d.name }}</div>
            </b-popover>
            <small class="text-muted">{{ display.displayCount }} displays</small>
        </template>
        <b-link v-else class="text-dark" :to="{ name: 'display-view', params: { displayId: display.displayId } }">{{ display.name }}</b-link>
    </div>
</b-th>
</template>

<script>
export default {
    name: 'IpamHeader',
    props: {
        display: {
            type: Object,
            required: true
        },
        isTag: {
            type: Boolean,
            default: false
        },
    },
    methods: {

    }
}
</script>

<style>
.ipam-header {
    line-height: 1em;
    max-height: 4em;
    white-space: wrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
a {
    display: block;
}
</style>